export const SUPPORTED_EXTENSIONS = [
  '.csv',
  '.json',
  '.txt',
  '.zip',
  '.tar',
  '.tar.gz',
  '.tgz',
];

export const ARCHIVE_EXTENSIONS = ['.zip', '.tar', '.tar.gz', '.tgz'];
